// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"280":"e3c7cc21","516":"87fbcdd6"}[chunkId] + ".chunk.css";
};